import React, { useCallback, useEffect } from 'react';
import { TimeSignalClassification } from 'graphql/types';
import { useNotesBackgroudTimerContext } from 'modules/NotesBackgroudTimer/context/NotesBackgroudTimerContext';

import { TimerDialog } from './TimerDialog';
type BackgroundTimerProps = {
  open: boolean;
  onSecondaryAction: () => void | Promise<void>;
  onPrimaryAction: () => void | Promise<void>;
  keepTimerRunningAction: () => void | Promise<void>;
  onClose: () => void | Promise<void>;
  selectedClassification?: TimeSignalClassification;
};

export const BackgroundTimer: React.FC<BackgroundTimerProps> = ({
  open,
  onSecondaryAction,
  onPrimaryAction,
  keepTimerRunningAction,
  onClose,
  selectedClassification
}: BackgroundTimerProps) => {
  const {
    running: isBackgroundTimerRunning,
    saveStartTime,
    setSaveStartTime
  } = useNotesBackgroudTimerContext();

  const keepTimerRunning = useCallback(() => {
    if (!isBackgroundTimerRunning) {
      setSaveStartTime(true);
      return;
    }
    keepTimerRunningAction();
  }, [isBackgroundTimerRunning, setSaveStartTime, keepTimerRunningAction]);

  useEffect(() => {
    if (!saveStartTime) {
      return;
    }
    if (!isBackgroundTimerRunning && saveStartTime) {
      keepTimerRunningAction();
    }
  }, [isBackgroundTimerRunning, saveStartTime, keepTimerRunningAction]);

  return (
    <TimerDialog
      open={open}
      onSecondaryAction={onSecondaryAction}
      onPrimaryAction={onPrimaryAction}
      onClose={onClose}
      selectedClassification={selectedClassification}
      keepTimerRunningAction={keepTimerRunning}
    />
  );
};
